const STATS = [
  { value: '4+', label: 'Years Experience' },
  { value: '10+', label: 'Technologies' },
  { value: '3', label: 'Countries Experience' },
  { value: '∞', label: 'Curiosity & Problem Solving' },
];

const SKILL_GROUPS = [
  {
    category: 'Backend',
    icon: 'ri-code-s-slash-line',
    skills: ['Node.js', 'Flask', 'Python', 'Django', 'Laravel'],
  },
  {
    category: 'Frontend',
    icon: 'ri-layout-4-line',
    skills: ['React', 'Javascript', 'TailwindCSS', 'HTML/CSS', 'Typescript'],
  },
  {
    category: 'Database',
    icon: 'ri-server-line',
    skills: ['MongoDB', 'PostgreSQL', 'MySQL'],
  },
  {
    category: 'DevOps & Cloud',
    icon: 'ri-cloud-line',
    skills: ['Docker', 'AWS', 'Git', 'Linux'],
  },
];

export default function SkillsSection() {
  return (
    <section id="skills" className="py-24 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block px-4 py-1.5 bg-white text-emerald-700 text-xs font-semibold tracking-widest uppercase rounded-full mb-5">
            Skills & Expertise
          </span>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              What I bring
              <br />
              to the table
            </h2>
            <p className="text-gray-600 max-w-md leading-relaxed text-sm lg:text-base">
              From architecting distributed systems to crafting pixel-perfect UIs — I love tackling
              hard technical challenges and building products that developers and end users love.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-2xl p-6 flex flex-col gap-1"
            >
              <span
                className="text-4xl font-bold text-emerald-600"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {stat.value}
              </span>
              <span className="text-gray-500 text-sm">{stat.label}</span>
            </div>
          ))}
        </div>

        {/* Skill Groups */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SKILL_GROUPS.map((group) => (
            <div key={group.category} className="bg-white rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
                  <i className={`${group.icon} text-lg`}></i>
                </div>
                <span className="font-semibold text-gray-900 text-sm">{group.category}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {group.skills.map((skill) => (
                  <span
                    key={skill}
                    className="inline-block px-3 py-1 bg-gray-50 text-gray-700 text-xs font-medium rounded-full border border-gray-100"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}